import { Helmet } from "react-helmet-async";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Products from "@/components/Products";
import TradeTerms from "@/components/TradeTerms";
import About from "@/components/About";
import SupplyNetwork from "@/components/SupplyNetwork";
import Quality from "@/components/Quality";
import Markets from "@/components/Markets";
import RfqForm from "@/components/RfqForm";
import Contact from "@/components/Contact";
import { META, useLang } from "@/i18n";

const Home = () => {
  const { lang } = useLang();
  return (
    <main>
      <Helmet>
        <title>{META[lang].title}</title>
        <meta name="description" content={META[lang].desc} />
      </Helmet>
      <Hero />
      <Marquee />
      <Products />
      <TradeTerms />
      <About />
      <SupplyNetwork />
      <Quality />
      <Markets />
      <RfqForm />
      <Contact />
    </main>
  );
};

export default Home;
